import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import image from '../../assets/homepage_pro12.png'
import image2 from '../../assets/homepage_star.png'
const DealOfTheWeek = () => {
    return (
        <>
            <div className="item">
                <h3>
                    <span>CAMERA</span> ASICS Gel Lyte III "Denim" Pack
                </h3>
                <div className="prod-img">
                    <span className="tag2">-$25</span>
                    <img className="img-fluid" src={image} alt="" />
                    <a href="#" className="btn-quick">
                        Quick View
                    </a>
                </div>
                <div className="price-prt">
                    <h4>$115.00</h4>
                    <span>
                        <img src={image2} alt="" />
                    </span>
                </div>
                <div className="">
                    <div>
                       <ProgressBar variant="success" now={60} />
                    </div>
                </div>
                <div className="avail-bx">
                    <h4 className="float-left">
                        ALREADY SOLD: <span>20</span>
                    </h4>
                    <h4 className="float-right">
                        AVAILABLE: <span>35</span>
                    </h4>
                </div>
                <div className="d-flex justify-content-between cd100 mt-4">
                    <div className="count-bx text-center">
                        <span className="number-bx days">10</span>
                        <span className="s1-txt1">Days</span>
                    </div>
                    <div className="count-bx text-center">
                        <span className="number-bx hours">12</span>
                        <span className="s1-txt1">Hours</span>
                    </div>
                    <div className="count-bx text-center">
                        <span className="number-bx minutes">00</span>
                        <span className="s1-txt1">Minutes</span>
                    </div>
                    <div className="count-bx text-center">
                        <span className="number-bx seconds">00</span>
                        <span className="s1-txt1">Seconds</span>
                    </div>
                </div>
            </div>

        </>
    )
}

export default DealOfTheWeek